import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../shared/shared.module';
import { UsageLimitCardComponent } from './components/usage-limit-card/usage-limit-card.component';
import { UsageKeyMetricsHeroComponent } from './components/usage-key-metrics-hero/usage-key-metrics-hero.component';
import { UsageDataQualityPillComponent } from './components/usage-data-quality-pill/usage-data-quality-pill.component';
import { UsageFreshnessIndicatorComponent } from './components/usage-freshness-indicator/usage-freshness-indicator.component';
import { DecisionsTableComponent } from './components/decisions-table/decisions-table.component';
import { UsageSkeletonComponent } from './components/usage-skeleton/usage-skeleton.component';
import { TrialCountdownBannerComponent } from './components/trial-countdown-banner/trial-countdown-banner.component';
import { PlanUpgradeCtaComponent } from './components/plan-upgrade-cta/plan-upgrade-cta.component';
import { PlanUpgradeConfirmDialogComponent } from './components/plan-upgrade-confirm-dialog/plan-upgrade-confirm-dialog.component';
import { PaymentStatusCardComponent } from './components/payment-status-card/payment-status-card.component';
import { PlanLimitBannerComponent } from './components/plan-limit-banner/plan-limit-banner.component';
import { CurrencyAmountPipe } from './pipes/currency-amount.pipe';
import { LimitLabelPipe } from './pipes/limit-label.pipe';

const DECLARATIONS = [
  UsageLimitCardComponent,
  UsageKeyMetricsHeroComponent,
  UsageDataQualityPillComponent,
  UsageFreshnessIndicatorComponent,
  DecisionsTableComponent,
  UsageSkeletonComponent,
  TrialCountdownBannerComponent,
  PlanLimitBannerComponent,
  PlanUpgradeCtaComponent,
  PlanUpgradeConfirmDialogComponent,
  PaymentStatusCardComponent,
  CurrencyAmountPipe,
  LimitLabelPipe
];

@NgModule({
  declarations: DECLARATIONS,
  imports: [
    CommonModule,
    RouterModule,
    SharedModule
  ],
  exports: [
    ...DECLARATIONS,
    CommonModule,
    RouterModule,
    SharedModule
  ]
})
export class PlansSharedModule {}
